// extracted by mini-css-extract-plugin
export default {"menuAppend":"CP9W8sw"};